
import { Link } from 'react-router-dom';

const upcomingFestivals = [
  {
    id: 'mother',
    month: '5月',
    festival: '母親節',
    flowers: '康乃馨、繡球花',
    image: 'https://public.readdy.ai/ai/img_res/6e2943ab5829c06d650fd4639a562fc8.jpg',
  },
  {
    id: 'graduation',
    month: '6月',
    festival: '畢業季',
    flowers: '向日葵、滿天星',
    image: 'https://readdy.ai/api/search-image?query=Cheerful%20graduation%20flower%20bouquet%20with%20bright%20sunflowers%20and%20baby%20breath%20celebratory%20arrangement%20yellow%20and%20white%20colors%20professional%20florist%20photography%20clean%20background&width=400&height=400&seq=grad004&orientation=squarish',
  },
  {
    id: 'qixi',
    month: '8月',
    festival: '七夕情人節',
    flowers: '永生花盒、玫瑰花束',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20Qixi%20Valentine%20preserved%20flower%20box%20with%20roses%20elegant%20gift%20box%20design%20pink%20and%20red%20colors%20professional%20florist%20photography%20luxury%20presentation%20clean%20background&width=400&height=400&seq=qixi005&orientation=squarish',
  },
  {
    id: 'christmas',
    month: '12月',
    festival: '聖誕節',
    flowers: '聖誕花圈、聖誕紅',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Christmas%20floral%20wreath%20with%20red%20poinsettia%20and%20white%20roses%20festive%20holiday%20decoration%20pine%20branches%20professional%20florist%20photography%20clean%20white%20background&width=400&height=400&seq=xmas006&orientation=squarish',
  },
];

export default function SeasonalPromo() {
  return (
    <section className="py-20 bg-gradient-to-b from-rose-50 to-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 px-4 py-2 bg-teal-50 text-teal-600 rounded-full text-sm font-medium mb-4">
            <i className="ri-calendar-event-line"></i>
            節日花禮預約
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            重要節日<span className="text-teal-600">提前預約</span>
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            讓每個重要時刻都有 Monceau Fleurs 的法式花藝相伴，提前預約享專屬優惠
          </p>
        </div>

        {/* Festival Cards */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-10">
          {upcomingFestivals.map((item, index) => (
            <Link
              key={item.id}
              to="/seasonal-booking"
              className="group relative bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="relative w-full h-40 md:h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.festival}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                <div className="absolute top-3 left-3 px-2.5 py-1 bg-white/90 backdrop-blur-sm rounded-full text-xs font-medium text-gray-700">
                  {item.month}
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="text-white font-bold text-lg mb-1">{item.festival}</h3>
                  <p className="text-white/80 text-xs">{item.flowers}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* CTA Section */}
        <div className="relative rounded-3xl overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20French%20florist%20shop%20interior%20with%20beautiful%20flower%20arrangements%20roses%20and%20seasonal%20blooms%20soft%20natural%20lighting%20warm%20atmosphere%20professional%20photography%20wide%20angle&width=1200&height=400&seq=promo001&orientation=landscape"
              alt="花店氛圍"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
          </div>
          
          <div className="relative px-6 md:px-12 py-12 md:py-16 flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="text-center md:text-left">
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-3">
                立即預約節日花禮
              </h3>
              <p className="text-white/80 text-sm md:text-base max-w-lg">
                提前預約可享優先選花、專屬客製化服務，讓您的心意完美傳達
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row items-center gap-4">
              <Link
                to="/seasonal-booking"
                className="inline-flex items-center gap-2 px-8 py-4 bg-teal-500 text-white rounded-full font-bold hover:bg-teal-600 transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-calendar-check-line text-xl"></i>
                立即預約
              </Link>
              <a
                href="https://www.instagram.com/monceautaiwan/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-4 bg-white/20 backdrop-blur-sm text-white rounded-full font-medium hover:bg-white/30 transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-instagram-line text-xl"></i>
                看更多作品
              </a>
            </div>
          </div>
        </div>

        {/* Features */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-10">
          <div className="flex items-center gap-4 p-5 bg-white rounded-xl shadow-sm">
            <div className="w-12 h-12 flex items-center justify-center bg-teal-50 rounded-xl flex-shrink-0">
              <i className="ri-vip-crown-line text-2xl text-teal-600"></i>
            </div>
            <div>
              <h4 className="font-bold text-gray-900 mb-1">會員專屬優惠</h4>
              <p className="text-sm text-gray-600">預約享點數加倍回饋</p>
            </div>
          </div>
          
          <div className="flex items-center gap-4 p-5 bg-white rounded-xl shadow-sm">
            <div className="w-12 h-12 flex items-center justify-center bg-rose-50 rounded-xl flex-shrink-0">
              <i className="ri-truck-line text-2xl text-rose-500"></i>
            </div>
            <div>
              <h4 className="font-bold text-gray-900 mb-1">準時配送</h4>
              <p className="text-sm text-gray-600">指定日期時段送達</p>
            </div>
          </div>
          
          <div className="flex items-center gap-4 p-5 bg-white rounded-xl shadow-sm">
            <div className="w-12 h-12 flex items-center justify-center bg-amber-50 rounded-xl flex-shrink-0">
              <i className="ri-hand-heart-line text-2xl text-amber-500"></i>
            </div>
            <div>
              <h4 className="font-bold text-gray-900 mb-1">客製化服務</h4>
              <p className="text-sm text-gray-600">依需求量身打造花禮</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
